import { Component } from '@angular/core';
import { SpinnerService } from 'app/api/services/spinnerService';


@Component({
    selector: 'app-global-spinner',
    templateUrl: './spinerComponent.html',
    styleUrls: ['./spinerComponent.scss'],
    standalone: false
})
export class SpinnerComponent {
  isLoading$ = this.spinnerService.spinnerVisible$;

  constructor(private spinnerService: SpinnerService) {}
}
